import { Dispatch, SetStateAction } from 'react';
import useLocalStorage from 'use-local-storage';

interface CrossLinkInfoBoxStore {
  visible: boolean;
  lastCloseDate: Date | null;
  closedTimes: number;
}

function useCrossLinkInfoBoxStore(): {
  crossLinkInfoBoxStore: CrossLinkInfoBoxStore;
  setCrossLinkInfoBoxStore: Dispatch<SetStateAction<CrossLinkInfoBoxStore | undefined>>;
} {
  const [crossLinkInfoBoxStore, setCrossLinkInfoBoxStore] = useLocalStorage('crossLinkInfoBoxStore', {
    visible: true,
    lastCloseDate: null as Date | null,
    closedTimes: 0
  });

  return { crossLinkInfoBoxStore, setCrossLinkInfoBoxStore };
}

export default useCrossLinkInfoBoxStore;
